import { useTranslation } from 'react-i18next';
import React, { memo, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import cx from 'clsx';
import { UnionAvatar, EmptyRecord, UnionFollowButtonV2, UserCardPopup } from '@/components';
import { useNewlyOfficials } from '../../../../hooks';
import styles from './index.module.scss';
import { getOfficialPath, openNewWindow } from '@/utils';

const SkeletonList = memo(({ count = 5 }) => (
  <div>
    {Array(count)
      .fill(0)
      .map((_, i) => (
        <div className={styles.item} key={i}>
          <Skeleton circle height={32} width={32} className={styles.avatar} />
          <div className={styles.userName}>
            <Skeleton width={80} />
          </div>
        </div>
      ))}
  </div>
));

const NewlyOfficialAccount = memo(({ data }: { data: OfficialAccount }) => {
  const handleUserClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      openNewWindow(`${getOfficialPath(data as OfficialAccount)}/stream`, '_blank');
    },
    [data],
  );

  const followButtonCb = useCallback(() => {}, []);

  return (
    <div className={styles.item}>
      <div onClick={handleUserClick} className={styles.avatar}>
        <UnionAvatar
          data={data}
          size={32}
          userCardPopup={{
            followCallback: followButtonCb,
          }}
        />
      </div>
      <div className={styles.userName} onClick={handleUserClick}>
        <UserCardPopup address={String(data.id)} followCallback={followButtonCb}>
          <div className={styles.officialId}>{(data as OfficialAccount).name}</div>
        </UserCardPopup>
        {data?.id ? (
          <UnionFollowButtonV2 address={data?.id} isFollowing={data?.is_following} />
        ) : null}
      </div>
    </div>
  );
});

export const NewlyOfficials = memo(() => {
  const { t } = useTranslation();

  const { data, isLoading } = useNewlyOfficials();

  return (
    <div className={cx(styles.container)}>
      {isLoading ? (
        <SkeletonList />
      ) : data?.length ? (
        <>{data?.map((x, i) => <NewlyOfficialAccount data={x} key={i} />)}</>
      ) : (
        <EmptyRecord
          content={<span className={styles.emptyDesc}>{t('NewlyOfficialAccount.1h54wbj')}</span>}
          iconType="user"
          className={styles.emptyList}
        />
      )}
    </div>
  );
});
